import SVGIconWrapper from "./SVGIconWrapper"

const IconChevronDownLoadMore = (props) => (
    <SVGIconWrapper
        fill={props.fill ?? "#444444"}
        style={props.style}
        viewBox="0 0 35 11"
        iconClass={`icon--chevron-down-load-more ${props.iconClass}`}
        wrapperClass={props.wrapperClass}
        onClick={props.onClick}
    >
        <path d="M1 0L0 1.8 17 11h1l17-9.2L34 0 17.5 9 1 0z" />
    </SVGIconWrapper>
)

export default IconChevronDownLoadMore
